import lottie from "lottie-web";

document.querySelectorAll<HTMLElement>("[data-lottie-animation]").forEach((el) => {
	const path = el.dataset.lottieAnimation;
	if (!path) return;

	lottie.loadAnimation({
		container: el,
		renderer: "svg",
		loop: "lottieLoop" in el.dataset,
		autoplay: "lottieAutoplay" in el.dataset,
		path,
	});
});